import { createPostAssociation } from "deso-protocol";
import { use } from "react";

import { UserContext } from "@/contexts/user-context";
import { AssociationReactionValue, AssociationType } from "@/utils/constants";

export const useUpvotePost = () => {
  const { currentUserPublicKey } = use(UserContext);

  const upvotePost = async ({ postHash }: { postHash: string }) => {
    await createPostAssociation({
      AssociationType: AssociationType.reaction,
      AssociationValue: AssociationReactionValue.LIKE,
      TransactorPublicKeyBase58Check: currentUserPublicKey,
      PostHashHex: postHash,
      MinFeeRateNanosPerKB: 0,
    });
  };

  return { upvotePost };
};
